import React from "react";
import { PlusIcon, MinusIcon, TrashIcon } from "./icons";
import { keyboardTrigger } from "@/helpers/utils";

export interface PlusMinusProps {
  value: number;
  min?: number;
  max?: number;
  decrement: () => void;
  increment: () => void;
  enableTrash: boolean;
  disabled?: boolean;
}

export const PlusMinus = ({
  value,
  decrement,
  increment,
  min,
  max,
  enableTrash,
  disabled = false,
}: PlusMinusProps) => {
  const minusIsClickAble =
    !disabled && (min === undefined || value > min || enableTrash === true);
  const plusIsClickAble = !disabled && (max === undefined || value < max);

  return (
    <div className="flex items-center justify-center outline outline-1 outline-primary-200">
      <div
        className={`group flex items-center justify-center p-1.5 text-primary transition ${
          disabled ? "cursor-not-allowed" : "cursor-pointer hover:bg-primary/10"
        } aria-disabled:opacity-50`}
        tabIndex={disabled ? -1 : 0}
        role="button"
        aria-label="reduce quantity by 1"
        aria-disabled={!minusIsClickAble}
        onClick={minusIsClickAble ? decrement : undefined}
        onKeyDown={minusIsClickAble ? keyboardTrigger(decrement) : undefined}
      >
        {value === 1 && enableTrash ? (
          <TrashIcon className="h-4 w-4 text-xl text-primary group-hover:text-primary-900" />
        ) : (
          <MinusIcon className="h-4 w-4 text-xl text-primary group-hover:text-primary-900" />
        )}
      </div>
      <div className="flex h-6 w-6 items-center justify-center text-center">
        <span className="sr-only">Quantity:</span>
        {value}
      </div>
      <div
        className={`group flex items-center justify-center p-1.5 text-xl text-primary transition ${
          disabled ? "cursor-not-allowed" : "cursor-pointer hover:bg-primary/10"
        } aria-disabled:opacity-50`}
        tabIndex={disabled ? -1 : 0}
        role="button"
        aria-label="increase quantity by 1"
        aria-disabled={!plusIsClickAble}
        onClick={plusIsClickAble ? increment : undefined}
        onKeyDown={plusIsClickAble ? keyboardTrigger(increment) : undefined}
      >
        <PlusIcon className="h-4 w-4 text-xl text-primary group-hover:text-primary-900" />
      </div>
    </div>
  );
};
